<template>
  <div
    class="food-categories-component d-flex mx-auto"
    :class="isCompactScreen ? 'food-categories-component--compact' : 'align-center'"
  >
    <!-- Компактный десктоп: поиск свёрнут в кнопку, по тапу - поле на всю ширину -->
    <v-btn
      v-if="isCompactScreen && !isSearchOpen"
      class="search-toggle"
      depressed
      title="Поиск по меню"
      @click="openSearch"
    >
      <font-awesome-icon color="#FF9100" icon="search" />
    </v-btn>
    <div v-show="!isCompactScreen || isSearchOpen" class="search-field">
      <v-text-field
        ref="search"
        v-model="localSearch"
        solo
        hide-details="auto"
        clearable
        placeholder="Поиск..."
        height="4.57em"
        @blur="closeSearchIfEmpty"
        @click:clear="searchOpen = false"
      >
        <template slot="append">
          <font-awesome-icon color="#FF9100" icon="search" />
        </template>
      </v-text-field>
    </div>
    <!-- Компактный десктоп: вместо подборок - категории меню, сайдбар с ними свёрнут -->
    <div v-if="isCompactScreen" v-show="!isSearchOpen" class="categories">
      <v-btn
        v-for="category in categoriesList"
        :key="category.id"
        class="button font-weight-medium text-normalize"
        :class="{ 'v-item--active': category.id === currentCategory }"
        depressed
        @click="selectCategory(category.id)"
      >
        {{ category.name }}
      </v-btn>
    </div>
    <v-btn-toggle
      v-else
      v-model="localCurrentCollection"
      dense
      group
      class="btn-toggle mx-auto"
    >
      <v-slide-group show-arrows>
        <v-slide-item v-for="(collection, i) in collections" :key="i">
          <v-btn
            :value="collection.id"
            class="button font-weight-medium text-normalize"
            depressed
          >
            {{ collection.name }}
          </v-btn>
        </v-slide-item>
      </v-slide-group>
    </v-btn-toggle>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import orderEdit from '@/mixins/order-edit'
  import compactScreen from '@/mixins/compact-screen'
  import orderMenuCategories from '@/mixins/order-menu-categories'

  export default {
    name: 'FoodCategories',
    mixins: [
      orderEdit,
      compactScreen,
      orderMenuCategories,
    ],
    data () {
      return {
        searchOpen: false,
      }
    },
    computed: {
      // поле открыто и пока в нём есть текст: иначе не видно, что меню отфильтровано
      isSearchOpen () {
        return this.searchOpen || !!this.searchMenu
      },
      currentCollection () { return this.orderState.currentCollectionId },
      menuItemsList () { return this.orderState.menuItemsList },
      collections () { return this.orderState.collectionsList },
      currentStep () { return this.orderState.currentStep },
      searchMenu () { return this.orderState.searchMenu },
      localSearch: {
        get () {
          return this.searchMenu
        },
        set (value) {
          this.$store.commit(this.orderEditPrefix + '/setSearchMenu', value)
        },
      },
      localCurrentCollection: {
        get () {
          return this.currentCollection
        },
        set (value) {
          if (value !== undefined) {
            this.$store.commit(this.orderEditPrefix + '/setMenuItemsLoading', true)
            this.$store
              .dispatch('collections/fetchFilialMenuSingleCollections', value, this.basketFilialId)
              .then((res) => {
                if (res.status === 200) {
                  this.$store.commit(
                    this.orderEditPrefix + '/setMenuItemsList',
                    res.data.data.menuItems,
                  )
                }
                this.$store.commit(this.orderEditPrefix + '/setMenuItemsLoading', false)
              })
          } else {
            this.$store.commit(this.orderEditPrefix + '/setMenuItemsLoading', true)
            const id = this.currentCategory
            const meta = {
              cur_region_id: this.basketFilialId,
            }
            this.$store
              .dispatch('categories/fetchFilialMenuSingleCategories', { id, meta })
              .then((res) => {
                if (res.status === 200) {
                  this.$store.commit(
                    this.orderEditPrefix + '/setMenuItemsList',
                    res.data.data.menuItems,
                  )
                }
                this.$store.commit(this.orderEditPrefix + '/setMenuItemsLoading', false)
              })
          }
          this.$store.commit(this.orderEditPrefix + '/setCurrentCollectionId', value)
        },
      },
    },
    beforeDestroy () {
      this.$store.commit(this.orderEditPrefix + '/setSearchMenu', '')
    },
    methods: {
      openSearch () {
        this.searchOpen = true
        this.$nextTick(() => this.$refs.search.focus())
      },
      closeSearchIfEmpty () {
        if (!this.searchMenu) {
          this.searchOpen = false
        }
      },
      selectCategory (id) {
        this.localCategory = id
        this.changeCategory(id)
      },
    },
  }
</script>

<style lang="less" scoped>
.food-categories-component {
  margin-bottom: 2.5em;
  max-width: 100%;
  height: 4.57em;
  font-size: 12px;

  .media-xl({
    font-size: 14px;
  });

  .search-field {
    width: 35%;

    .media-xl({
      width: 40%;
    });

    &::v-deep {
      .v-input {
        font-size: 1em;

        input {
          font-size: 1.4em;
        }
      }
      .v-input__slot {
        height: 4.57em;
        border-radius: 5px;
        box-shadow: none !important;
      }
      .v-input__slot {
        background-color: @color-secondary !important;
      }

      label {
        color: #c4cdd9 !important;
      }
    }
  }

  .btn-toggle {
    max-width: 65%;
    .media-xl({
      max-width: 60%;
    });
  }

  .button {
    border-radius: 10px;
    font-size: 1.14em;
    line-height: 21px;
    background-color: @color-secondary !important;
    height: 4.01em;
    padding: 0 23px;
    margin-right: 1.31em;
    &:before {
      content: none;
    }
    &.v-item--active {
      background-color: @color-primary !important;
      color: #ffffff;
    }
  }

  // Компактный десктоп: кнопка поиска и категории меню - один блок с переносом,
  // вторая строка начинается от левого края. Кнопки по ширине названия
  &--compact {
    flex-wrap: wrap;
    gap: 8px;
    align-items: flex-start;
    height: auto;
    margin-bottom: 16px;

    .search-toggle {
      flex: 0 0 auto;
      width: 48px;
      min-width: 48px;
      height: 48px;
      padding: 0;
      border-radius: 10px;
      background-color: @color-secondary !important;
      font-size: 18px;
    }

    .search-field {
      width: 100%;
    }

    // обёртка категорий не участвует в раскладке: кнопки стоят в одном ряду с лупой
    .categories {
      display: contents;
    }

    // 16px: с учётом зума оболочки на POS-терминале (около 0,9) остаётся читаемым
    .button {
      height: 48px;
      padding: 0 16px;
      margin-right: 0;
      font-size: 16px;
      letter-spacing: normal;
    }
  }
}
</style>
